import React, { useEffect } from "react";
import { BASE_URL } from "../env";

const Hybridexambybatches = () => {
	const [datas, setDatas] = React.useState([]);
	useEffect(() => {
		fetch(BASE_URL + "/gethybridbatch", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setDatas(data.batches);
			});
	}, []);
	return (
		<div>
			{datas.map((data) => {
				return (
					<h1>
						<a href={"/allbatcheshybrid/" + data}> {data}</a>
					</h1>
				);
			})}
		</div>
	);
};

export default Hybridexambybatches;
